module.exports = __webpack_public_path__ + "bdb8f722b009c94cb2e89d235df7198e.pdf";